"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineTotalByType = void 0;
const roundTo_1 = require("../roundTo");
const getRoomRateSummary_1 = require("./getRoomRateSummary");
const hotel_1 = require("../hotel");
const getOrderLineTotalByType = (config, type, date) => {
    let total = 0;
    switch (type) {
        case "GOLF": {
            const golf_config = config;
            const { green_fee, caddies, carts, where_when_who, product, adjustments, } = golf_config;
            const custom_rate = product?.custom || false;
            // Adjustments.  If it's a custom rate, we don't apply the margin discount
            const margin_discount_percentage = custom_rate
                ? 0
                : adjustments?.margin_discount_percentage || 0;
            // discount the green fee margin
            const margin = green_fee?.margin -
                (green_fee?.margin * margin_discount_percentage) / 100;
            // Green Fee
            total =
                (green_fee?.cost + margin) * where_when_who?.number_of_golfers +
                    Number(where_when_who.number_of_golfers % 2 ? green_fee?.surcharge || 0 : 0);
            // Caddies
            if (caddies?.total &&
                caddies?.enabled &&
                caddies?.payment_option &&
                caddies?.payment_option !== "ON_ARRIVAL") {
                total += caddies?.total;
            }
            // Carts
            if (carts?.enabled &&
                carts?.payment_option &&
                carts?.payment_option !== "ON_ARRIVAL") {
                carts?.types?.map(
                // eslint-disable-next-line array-callback-return
                (cart_type) => {
                    total += cart_type?.total;
                });
            }
            break;
        }
        case "HOTEL": {
            const hotel_config = config;
            const { adjustments, rooms } = hotel_config;
            // Adjustments
            const custom_rate = rooms?.custom || false;
            // Adjustments.  If it's a custom rate, we don't apply the margin discount
            const margin_discount_percentage = custom_rate
                ? 0
                : adjustments?.margin_discount_percentage || 0;
            total = hotel_config.rooms.rooms.reduce((acc, room) => {
                const applied_discount = (0, hotel_1.getFilteredRoomDiscounts)(date || hotel_config.date_of_confirmation, hotel_config?.where_when_who?.check_in_date, room.applied_discount);
                // i may need to do some checking on the applied discount at this point incase any of the options have passed etc. (e.g. early bird discounts)
                const price_summary = (0, getRoomRateSummary_1.getRoomRateSummary)(room.rate, room.occupancy, room.extra_bed, margin_discount_percentage, applied_discount);
                // this will always return the total price with the discount applied
                return acc + price_summary.total_price_discounted;
            }, 0);
            break;
        }
        case "EXCURSION": {
            const excursion_config = config;
            const { adjustments, product } = excursion_config;
            // Adjustments
            const custom_rate = product?.custom || false;
            // Adjustments.  If it's a custom rate, we don't apply the margin discount
            const margin_discount_percentage = custom_rate
                ? 0
                : adjustments?.margin_discount_percentage || 0;
            const margin = (excursion_config?.product?.rate?.margin || 0) -
                ((excursion_config?.product?.rate?.margin || 0) *
                    margin_discount_percentage) /
                    100;
            let quantity = excursion_config?.where_when_who?.number_of_people || 0;
            if (excursion_config?.product?.rate?.pricing_type === "PER_GROUP") {
                quantity = Math.ceil(quantity / (excursion_config?.product?.rate?.max_pax || 0));
            }
            const calculated_total = ((excursion_config?.product?.rate?.cost_price || 0) + margin) *
                quantity;
            total = calculated_total || 0;
            break;
        }
        case "TRANSFER": {
            const transfer_config = config;
            const { adjustments, vehicle } = transfer_config;
            // Adjustments
            const custom_rate = vehicle?.rate?.type === "CUSTOM";
            // Adjustments.  If it's a custom rate, we don't apply the margin discount
            const margin_discount_percentage = custom_rate
                ? 0
                : adjustments?.margin_discount_percentage || 0;
            const cost = transfer_config.vehicle.cost || 0;
            let margin = transfer_config.vehicle.margin || 0;
            if (margin_discount_percentage) {
                margin = margin - (margin * margin_discount_percentage) / 100;
            }
            const quantity = transfer_config.vehicle.quantity || 0;
            if (transfer_config.vehicle) {
                total = (cost + margin) * quantity;
            }
            break;
        }
        case "CUSTOM": {
            const custom_config = config;
            // Adjustments
            const margin_discount_percentage = 0;
            const cost = custom_config?.pricing?.cost || 0;
            let margin = custom_config?.pricing?.margin || 0;
            if (margin_discount_percentage) {
                margin = margin - (margin * margin_discount_percentage) / 100;
            }
            total = cost + margin || 0;
            break;
        }
    }
    return (0, roundTo_1.roundTo)(total, 2);
};
exports.getOrderLineTotalByType = getOrderLineTotalByType;
